import { render, staticRenderFns } from "./VPackageSelector.vue?vue&type=template&id=9a21ad8c&scoped=true"
import script from "./VPackageSelector.vue?vue&type=script&lang=js"
export * from "./VPackageSelector.vue?vue&type=script&lang=js"
import style0 from "./VPackageSelector.vue?vue&type=style&index=0&id=9a21ad8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a21ad8c",
  null
  
)

export default component.exports